import { defineStore } from 'pinia';
import { notify } from 'notiwind';

export const useMembersStore = defineStore('members', {
    state: () => ({
        loadingMembers: false,
        showChallengeModal: false,
        showConnectModal: false,
        members: [],
        membersByUser: {}, // New state property to store members organized by user
        sharedUsers: [],
        walletId: 0,
        banks: [],
        member: {},
        connectType: '',
        users: [],
        wallet: {},
    }),
    actions: {
        /**
         * Process members and organize them by user_guid
         * @param {Array} members - Array of member objects to process
         * @param {Object} membersByUser - Existing membersByUser object to add to
         * @returns {Object} Updated membersByUser object
         */
        processMembersByUser(members, membersByUser = {}) {
            if (!members || !members.length) return membersByUser;

            members.forEach((member) => {
                const userGuid = member.user_guid || 'unknown';
                if (!membersByUser[userGuid]) {
                    membersByUser[userGuid] = {
                        // Use member.wallet_user if available, otherwise find the user by token
                        user:
                            member.wallet_user && member.wallet_user !== false
                                ? member.wallet_user
                                : null,
                        members: [],
                    };
                }
                membersByUser[userGuid].members.push(member);
            });

            return membersByUser;
        },

        getMembers(uuid = null) {
            this.loadingMembers = true;
            ApiService.apiCall('/wallets/members?uuid=' + uuid, 'get')
                .then((response) => {
                    this.walletId = response.data.wallet.id;
                    this.members = response.data.members;
                    this.sharedUsers = response.data.shared_users;
                    this.banks = response.data.banks;
                    this.users = response.data.wallet.users;
                    this.wallet = response.data.wallet;

                    // Organize members by user_guid
                    let membersByUser = {};

                    // Process regular members
                    membersByUser = this.processMembersByUser(
                        this.members,
                        membersByUser
                    );

                    // Process shared users' members
                    if (this.sharedUsers && this.sharedUsers.length) {
                        this.sharedUsers.forEach((sharedUserMembers) => {
                            membersByUser = this.processMembersByUser(
                                sharedUserMembers,
                                membersByUser
                            );
                        });
                    }

                    this.membersByUser = membersByUser;

                    setTimeout(() => {
                        this.loadingMembers = false;
                    }, 500);
                })
                .catch((response) => {
                    this.$root.handleHttpStatus(response);
                    this.loadingMembers = false;
                });
        },
        deleteMember(guid) {
            return new Promise((resolve, reject) => {
                ApiService.apiCall(
                    '/wallets/' + this.walletId + '/members/' + guid,
                    'delete'
                )
                    .then((response) => {
                        this.getMembers();
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        setShowChallengeModal(val, member) {
            this.member = member;
            this.showChallengeModal = val;
        },
        setShowConnectModal(val, member, type) {
            this.member = member;
            this.connectType = type;
            this.showConnectModal = val;
        },
    },
});
